import { MutationOptions, MutationResult, UseQueryOptions } from '@lib/types';
import useQuery from '@lib/useQuery';
import envStore from '@utils/env';
import request from './request';
import { useMutation } from 'react-query';
import { GetHeader } from './BaseApi';
import axios from 'axios';
import AuthServiceApi from './api/Auth';

type TResponse = {
  data: any[] | any;
  message: any;
  error: boolean;
  messageCode: string;
};

// intervel gửi device token lên server dùng phương thưc Put
export const useExtendDeviceToken = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.url_auth + 'api/Auth/UpdateDeviceToken', { headers: GetHeader(), body: body, method: 'PUT' }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

// dùng phương thức get
export const useProductMix = (options?: UseQueryOptions) => {
  const { data, ...rest } = useQuery<TResponse>(envStore.apiBaseUrl + 'api/Product/GetPaging', options);
  // tracking lỗi
  if (data?.error) {
    console.log(' đã xảy ra lỗi khi query productmix');
  }
  return {
    ...rest,
    data
  };
};

export const useCustomers = (options?: UseQueryOptions) => {
  const { data, ...rest } = useQuery<TResponse>(envStore.apiBaseUrl + 'api/Customer/All', options);
  // tracking lỗi
  if (data?.error) {
    console.log(' đã xảy ra lỗi khi query customers');
  }
  return {
    ...rest,
    data
  };
};

export const useFeeTracking = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/FeeTracking/GetFeeTrackingOrders', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useDetailFeeTracking = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/FeeTracking/GetDetailFeeTrackingOrders', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

// export const useInVoices = (options: any = {}) => {
//   const { mutate, isLoading } = useMutation(
//     (body: Partial<any>) =>
//       request(envStore.apiBaseUrl + 'api/InVoice/GetListInVoice', {
//         headers: GetHeader(),
//         body: body,
//         method: 'POST'
//       }),
//     options
//   );

//   return [isLoading, mutate] as MutationResult;
// };

export const useInVoicesV2 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/InVoice/GetListInVoiceV2', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useFeeTrackingHistory = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/FeeTracking/GetFeeCollectionSessions', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useFeeTrackingAccountant = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/FeeTracking/GetEligibleAccountantCollectFee', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOMConfig = () => {
  const { data, ...rest } = useQuery<TResponse>(envStore.apiBaseUrl + 'api/OMConfig/GetAll');
  // tracking lỗi
  if (data?.error) {
    console.log(' đã xảy ra lỗi khi query OMConfig');
  }
  return {
    ...rest,
    data
  };
};

// dùng phương thức post
export const useLogs = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Log/Get', { headers: GetHeader(), body: body, method: 'POST' }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrders = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Order/Paging', { headers: GetHeader(), body: body, method: 'POST' }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

// sẽ dùng api mới này cho đơn hàng, không dùng mẫu api cũ ở trên (useOrders) nữa.
export const useOrdersV2 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Order/GetListOrder', { headers: GetHeader(), body: body, method: 'POST' }),
    options
  );
  return [isLoading, mutate] as MutationResult;
};

export const useOrderReport = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/GetOrderReport', { headers: GetHeader(), body: body, method: 'POST' }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportV2 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/GetOrderReportV2', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};
export const useDashboardKinhDoanh = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/DashBoardKinhDoanh', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useDashboardKeToan = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/DashBoardKeToan', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};
export const useDashboardKyThuat = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/DashBoardKyThuat', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};
export const useDashboardCSKH = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/DashBoardCSKH', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useDashboardGeneralInfomation = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/DashBoardGeneralInfomation', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportV3 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/GetOrderReportV3', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportV4 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/GetOrderReportV4', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportV5 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/GetOrderReportV5', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportV6 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/GetOrderReportPaging', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useAccountantsPayableReport = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/GetDetailDebtCustomer', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

// export const useCustomerV2 = (options: any = {}, page?: any, size?: any) => {
//   const { mutate, isLoading } = useMutation(
//     (body: Partial<any>) =>
//       request(envStore.apiBaseUrl + `api/Customer/AdvanceSearchCustomer?pageSize=${size}&pageIndex=${page}`, {
//         headers: GetHeader(),
//         body: body,
//         method: 'POST'
//       }),
//     options
//   );

//   return [isLoading, mutate] as MutationResult;
// };

// export const useCustomerV2 = (options: any = {}, page: number, size: number) => {
//   const { mutate, isLoading } = useMutation(
//     ({ body}: { body: any }) =>
//       request(
//         `${envStore.apiBaseUrl}api/Customer/AdvanceSearchCustomer?pageSize=${size}&pageIndex=${page !== 0 ? page : 1}`,
//         {
//         headers: GetHeader(),
//           body,
//           method: 'POST',
//         }
//       ),
//     options
//   );

//   const handleAdd = (body: any) => {
//     mutate({ body });
//   };

//   return [isLoading, handleAdd] as const;
// };

export const useCustomerV2 = (options: any = {}, page: number, size: number) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(
        envStore.apiBaseUrl + `api/Customer/AdvanceSearchCustomer?pageSize=${size}&pageIndex=${page !== 0 ? page : 1}`,
        { headers: GetHeader(), body: body, method: 'POST' }
      ),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportCSKH = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/BaoCaoCSKH', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useGetAdjustmentVouchers = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Order/GetAdjustmentVouchers', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportKT = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/BaoCaoKeToan', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportKTV2 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/BaoCaoKeToanV2', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportKTV4 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/BaoCaoKeToanV4', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useThongKeSim = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/ThongKeSim', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportCSKHV2 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/BaoCaoCSKHV2', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportCSKHV4 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/BaoCaoCSKHV4', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportTongQuanKD = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/BaoCaoTongQuanKinhDoanh', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportTongQuanKDV4 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/BaoCaoTongQuanKinhDoanhV4', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportThongKeLoiV4 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/ThongKeTheoLoiV4', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportThongKeLoiV5 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/ThongKeTheoLoiV5', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportThongKeLoiV6 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/ThongKeTheoLoiV6', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportThongKeHanldingV4 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/ThongKeTheoHandlerV4', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportThongKeHanldingV5 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/ThongKeTheoHandlerV5', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportThongKeHanldingV6 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/ThongKeTheoHandlerV6', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportThongKeSPLoiV4 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/ThongKeTheoSPLoiV4', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportThongKeSPLoiV5 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/ThongKeTheoSPLoiV5', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportThongKeSPLoiV6 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/ThongKeTheoSPLoiV6', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportChiTietKD = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/BaoCaoChiTietKinhDoanh', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportChiTietKDV4 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/BaoCaoChiTietKinhDoanhV4', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportKD = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/BaoCaoKinhDoanh', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportKho = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/BaoCaoKho', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportKhoV2 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/BaoCaoKhoKyThuat', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportKhoV4 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/BaoCaoKhoKyThuatV4', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportKyThuat = (options: any = {}, useV2?: boolean) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + (useV2 ? 'api/Report/GetBaoCaoChiTietKyThuat' : 'api/Report/BaoCaoKyThuat'), {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportKyThuatV4 = (options: any = {}, useV2?: boolean) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + (useV2 ? 'api/Report/GetBaoCaoChiTietKyThuatV4' : 'api/Report/BaoCaoKyThuat'), {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportDieuHanh = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/GetBaoCaoChiTietDieuHanh', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};

export const useOrderReportDieuHanhV4 = (options: any = {}) => {
  const { mutate, isLoading } = useMutation(
    (body: Partial<any>) =>
      request(envStore.apiBaseUrl + 'api/Report/GetBaoCaoChiTietDieuHanhV4', {
        headers: GetHeader(),
        body: body,
        method: 'POST'
      }),
    options
  );

  return [isLoading, mutate] as MutationResult;
};
